import React, { useState } from 'react';
import { Box, TextField, Button, MenuItem, Divider } from '@mui/material';

export const ProductListBox = ({
  downloadExl,
  uploadExl,
  handleAdd,
  formik,
}) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '25ch' },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="">검색키워드</MenuItem>
              <MenuItem value="partnerNm">제조사</MenuItem>
              <MenuItem value="productLine">제품군</MenuItem>
              <MenuItem value="productNm">제품명</MenuItem>
              <MenuItem value="modelNm">모델명</MenuItem>
              <MenuItem value="category">아이템명</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
            />
          </Box>

          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
        <Box textAlign="center">
          <Button color="primary" variant="contained" onClick={handleAdd}>
            추가
          </Button>
        </Box>

        <Box textAlign="center" sx={{ mx: 1 }}>
          <Button variant="contained" color="success" onClick={downloadExl}>
            엑셀 다운로드
          </Button>
        </Box>
        <Box textAlign="center">
          <Button variant="contained" color="warning" onClick={uploadExl}>
            엑셀 업로드
          </Button>
        </Box>
      </Box>
    </div>
  );
};
